"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButtonBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BaseButtonBar_1 = require("../BaseButtonBar/BaseButtonBar");
/**
 * IconButtonBar molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-iconbuttonbar--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/ButtonBars/IconButtonBar Source}
 */
var IconButtonBar = function (_a) {
    var entries = _a.entries, className = _a.className, dividerAtEnd = _a.dividerAtEnd;
    return ((0, jsx_runtime_1.jsx)(BaseButtonBar_1.BaseButtonBar, { entries: entries, dividerAtStart: !!entries.length, dividerAtEnd: dividerAtEnd, className: className }));
};
exports.IconButtonBar = IconButtonBar;
